var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'menu-open': _vm.menuOpen},attrs:{"id":"app-container"}},[(_vm.user.id)?_c('navbar'):_vm._e(),_c('main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"router-view",class:{'menu-open': _vm.menuOpen}})],1)],1),(_vm.user.id)?_c('the-menu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }